<div class="col gap-4">
  <h2>{{ headline?.main }}</h2>
  <!-- <div>{{ headline?.sub }}</div> -->
</div>
<div class="row gap-8 space-between control grow-1">
  <textarea
    [(ngModel)]="control.value"
    class="grow-1"
    [placeholder]="placeholder"
    #manualSugText
  ></textarea>
  <rr-icon
    name="add"
    [ngClass]="manualSugText.value == '' ? 'disabled' : ''"
    class="roundicon pointer"
    (click)="manualAddSuggestion(manualSugText.value)"
  ></rr-icon>
</div>
<div class="options-container w100 col gap-4">
  <div class="suggestion" *ngFor="let suggestion of options">
    <div
      class="row gap-8 align-center space-between parentelement disabled"
      #parentElem
    >
      <textarea
        class="disabled w100"
        #suggestionTextArea
        [(ngModel)]="suggestion.text"
      ></textarea>
      <div class="disabledtext">{{ suggestion.text }}</div>

      <div class="row pointer saveable-area">
        <rr-icon
          name="check-circle"
          class="grey"
          (click)="saveSuggestion(suggestionTextArea, parentElem)"
        ></rr-icon>
      </div>
      <div class="row gap-8 align-center pointer editable-area">
        <rr-icon
          name="edit"
          (click)="editSuggestion(suggestionTextArea, parentElem)"
        ></rr-icon>
        <rr-icon
          name="trash"
          (click)="deleteSuggestion.emit(suggestion)"
        ></rr-icon>
      </div>
    </div>
  </div>
</div>
<rr-divider></rr-divider>
<div class="suggestions-container w100 col gap-4">
  <div
    class="suggestion pointer"
    *ngFor="let suggestion of suggestions"
    (click)="addSuggestion.emit(suggestion)"
  >
    <div class="row gap-8 align-center space-between">
      <div>{{ suggestion.text }}</div>
      <rr-icon class="roundicon" name="add"></rr-icon>
    </div>
  </div>
</div>
<div class="row space-between">
  <rr-btn
    size="Medium"
    type="Primary"
    [disabled]="options.length === 0 || editmodus === true"
    (click)="
      options.length != 0 && editmodus === false ? nextQuestion.emit() : null
    "
    >Next</rr-btn
  >
  <rr-btn
    size="Medium"
    type="Secondary"
    iconStart="ai"
    (click)="suggestOptions.emit()"
    >Suggest Options</rr-btn
  >
</div>
